import React, { useState } from "react";
import * as S from "./styles";
import { cloneDeep } from "lodash";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

const BorderForSelectNumberOfRecords = ({ handleSearch, initialValue }) => {
  const label = "Número de cadastros";
  const list = [
    { id: 25, nome: "25 Cadastros" },
    { id: 50, nome: "50 Cadastros" },
    { id: 100, nome: "100 Cadastros" },
    { id: 500, nome: "500 Cadastros" },
    { id: 1000, nome: "1000 Cadastros" },
  ];
  const [filtredValue, setFiltredValue] = useState(initialValue + " Cadastros");
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(cloneDeep(list));

  const handleOpen = () => {
    setOpen(!open);
  };

  const selection = (item) => {
    handleSearch(item);
    setFiltredValue(item?.nome);
    setOpen(false);
  };

  function handleFilter(e) {
    const value = e.target.value;
    setFiltredValue(e.target.value);

    if (!value || value === null || value === "") {
      setItems(
        list?.map((item) => ({
          id: item?.id,
          nome: item?.nome,
        }))
      );
      handleSearch(null);
    } else {
      setItems(
        items?.filter(
          (item) => item?.nome.toUpperCase().indexOf(value.toUpperCase()) !== -1
        )
      );
    }

    if (e && e.target.value.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  return (
    <>
      <S.Wrapper>
        <S.Main>
          <S.Select onClick={handleOpen}>
            <div className="Entrada">
              <div>
                <S.InputSearch
                  placeholder={label}
                  onChange={(e) => handleFilter(e)}
                  value={filtredValue}
                />
              </div>
              <div>
                {open ? (
                  <IoChevronUp size="2rem" />
                ) : (
                  <IoChevronDown size="2rem" />
                )}
              </div>
            </div>
          </S.Select>
          {open && (
            <S.Options>
              {items?.map((item) => (
                <S.Option key={item.id} onClick={() => selection(item)}>
                  <S.Description>
                    <div className="hover">{item?.nome}</div>
                  </S.Description>
                </S.Option>
              ))}
            </S.Options>
          )}
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default BorderForSelectNumberOfRecords;
